import { render, staticRenderFns } from "./myQuestion.vue?vue&type=template&id=0ccd1d90&scoped=true"
import script from "./myQuestion.vue?vue&type=script&lang=js"
export * from "./myQuestion.vue?vue&type=script&lang=js"
import style0 from "./myQuestion.vue?vue&type=style&index=0&id=0ccd1d90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccd1d90",
  null
  
)

export default component.exports